module.exports = __webpack_public_path__ + "static/media/s2.98d267ef.jpg";